import LocationEditorInput from "./LocationEditorInput";

export default LocationEditorInput;
